import React from 'react';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import { getImagePath } from '../../../../helpers/common';
import styled from 'styled-components';
import { EntityTypes } from '../../../../new-lib/constants/common';
import { useRouter } from 'next/router';
import OffersCTA from './entity-cards/OffersCTA';

const OfferHeader = ({ offer, onClick, closeModal }: any) => {
  const { locale } = useRouter();
  return (
    <OfferHeaderContainer
      onClick={closeModal ? onClick : undefined}
      locale={locale}
      closeModal={closeModal}
    >
      <div className="offer-image">
        <ImageWrapper
          src={getImagePath(offer.image)}
          fill
          className="compound-image"
          objectFit="cover"
          alt={offer.name}
          imageSize="high"
          quality={50}
          withSkeleton
        />
        {closeModal && (
          <ImageWrapper
            src={getImagePath(offer.developer.logo_path)}
            fill
            className="developer-image"
            objectFit="cover"
            alt={offer.developer.name}
            imageSize="medium"
            quality={50}
            withSkeleton
          />
        )}
      </div>
      <div className="offer-header-details">
        <div className="offer-title">
          <span className="compound-name">{offer.name}</span>
          <span className="area-name">{offer.area.name}</span>
        </div>
        {closeModal ? (
          <OffersCTA
            clickEventData={{
              eventAction: 'offer_click',
              eventLocation: 'CityScape_Offers',
              featureName: 'offers'
            }}
            offer={offer}
            entityType={EntityTypes.COMPOUND}
            closeModal={true}
          />
        ) : (
          <ImageWrapper
            src={getImagePath(offer.developer.logo_path)}
            fill
            className="developer-image"
            objectFit="cover"
            alt={offer.developer.name}
            imageSize="medium"
            quality={50}
            withSkeleton
          />
        )}
      </div>
    </OfferHeaderContainer>
  );
};

const OfferHeaderContainer = styled.div<any>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: ${props => (props.closeModal ? 'pointer' : 'default')};
  .offer-image {
    position: relative;
    width: 100%;
    min-height: 180px;

    .compound-image {
      border-radius: 12px;
    }
    .developer-image {
      width: 35px !important;
      height: 35px !important;
      inset: unset !important;
      border-radius: 50%;
      bottom: 7% !important;
      left: 3% !important;
    }
  }

  .offer-header-details {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0px;
    .developer-image {
      width: 50px !important;
      height: 50px !important;
      inset: unset !important;
      border-radius: 50%;
      bottom: 7% !important;
      right: ${props => (props.locale === 'en' ? '1% !important' : '')};
      left: ${props => (props.locale === 'ar' ? '1% !important' : '')};
    }
    div:nth-child(2) {
      gap: 8px;
    }
    .offer-title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      span {
        color: #1a2028;

        &.compound-name {
          font-family: materialSemiBold;
          font-size: 14px;
          line-height: 21px;
        }
        &.area-name {
          font-family: materialRegular;
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }
`;

export default OfferHeader;
